import { render, staticRenderFns } from "./update_info.vue?vue&type=template&id=5c3c808c&scoped=true&"
import script from "./update_info.vue?vue&type=script&lang=js&"
export * from "./update_info.vue?vue&type=script&lang=js&"
import style0 from "./update_info.css?vue&type=style&index=0&id=5c3c808c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3c808c",
  null
  
)

export default component.exports